import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { addExchangeBet } from '../../store';
import './ExchOutrightsEventTable.scss';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core';
import Spinner from '../Spinner/Spinner';

import Modal from '../../components/Modal/Modal';
import { BsData, PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import LAMBDA_API from '../../api-services/lambda-api';
import { useInterval } from '../../hooks/useInterval';
import { RootState } from '../../models/RootState';
import { UserBet } from '../../models/UserBet';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import { IonIcon } from '@ionic/react';

type OddsInfoMsg = {
  launch: boolean;
  oddsType?: string;
  eventTypeID: string;
};

type StoreProps = {
  addExchangeBet: (bet: PlaceBetRequest) => void;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
};

type PropType = StoreProps & {
  loggedIn: boolean;
};

const ExchOutrightsEventTable: React.FC<PropType> = (props) => {
  const { addExchangeBet, bets, openBets, loggedIn } = props;
  const [outrightEventData, setOutrightEventData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [minStake, setMinStake] = useState<number>(100);
  const [maxStake, setMaxStake] = useState<number>(500000);
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const tableFields = [
    {
      key: 'marketName',
      Label: 'Market',
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'back',
      Label: 'Back',
      className: 'odds-cell-head',
      align: 'center',
    },
    {
      key: 'lay',
      Label: 'Lay',
      className: 'odds-cell-head',
      align: 'center',
    },
  ];

  const fetchData = async () => {
    setLoading(true);
    const response = await LAMBDA_API.post(
      '/sports/get-outright-odds',
      {
        event_id: '28127348',
      },
      {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      }
    );
    setLoading(false);
    setOutrightEventData(response.data);
  };

  // Update outrights data for every 30 seconds.
  useInterval(() => {
    fetchData();
  }, 1000 * 30);

  useEffect(() => {
    fetchData();
  }, [loggedIn]);

  const getOpenBetsPL = (runner, retType: 'array' | 'number') => {
    let returns = null;
    for (let bet of openBets) {
      const plVal = bet.oddValue * bet.stakeAmount - bet.stakeAmount;
      if (bet.betType === 0) {
        if (bet.outcomeId.toString() === runner.selectionId.toString()) {
          returns ? (returns += plVal) : (returns = plVal);
        } else {
          returns
            ? (returns -= bet.stakeAmount)
            : (returns = 0 - bet.stakeAmount);
        }
      } else if (bet.betType === 1) {
        if (bet.outcomeId.toString() !== runner.selectionId.toString()) {
          returns ? (returns += bet.stakeAmount) : (returns = bet.stakeAmount);
        } else {
          returns ? (returns -= plVal) : (returns = 0 - plVal);
        }
      }
    }
    return retType === 'array' ? [returns] : returns;
  };
  const getTotalPL = (runner) => {
    let returns = null;
    const mBetslipBets = bets.filter((b) => b.amount && b.amount > 0);
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(runner, 'number');
      for (let bet of mBetslipBets) {
        const plVal = bet.oddValue * bet.amount - bet.amount;
        if (bet.betType === 'BACK') {
          if (bet.outcomeId === runner.selectionId) {
            returns ? (returns += plVal) : (returns = plVal);
          } else {
            returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
          }
        } else if (bet.betType === 'LAY') {
          if (bet.outcomeId !== runner.selectionId) {
            returns ? (returns += bet.amount) : (returns = bet.amount);
          } else {
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          }
        }
      }
    }
    return [returns];
  };

  return (
    <>
      <div className="ot-table-ctn">
        <div className="ot-table-content table-ctn">
          <TableContainer component={Paper}>
            <Table className="ot-table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3}>
                    <div className="market-name-cell-head-ctn">
                      <span>
                        Match Odds
                        <IonIcon
                          className="info-img"
                          onClick={() =>
                            setInfoDialog({
                              launch: true,
                              oddsType: 'MatchOdds',
                              eventTypeID: '4',
                            })
                          }
                          src={InfoImg}
                        />
                      </span>
                      <span>Min: 100 Max: 50K</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className="header-row">
                  {tableFields.map((tF, index) => (
                    <TableCell
                      key={tF.key + index}
                      align={
                        tF.align === 'left'
                          ? 'left'
                          : tF.align === 'right'
                          ? 'right'
                          : 'center'
                      }
                      colSpan={1}
                      className={tF.className}
                    >
                      {tF.key === 'lay' || 'back' ? (
                        <div className={tF.key.toLowerCase() + '-odd'}>
                          {tF.Label}
                        </div>
                      ) : (
                        tF.Label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
                {outrightEventData?.markets[0].runners.length > 0 ? (
                  <>
                    {outrightEventData?.markets[0].runners.map(
                      (runner, index) =>
                        runner.runnerName === 'Kings XI Punjab' ? null : (
                          <>
                            <TableRow key={'row-' + index}>
                              <TableCell className="team-name-cell">
                                <div className="team">
                                  {runner.runnerName}
                                  {getOpenBetsPL(runner, 'array').map((ret) =>
                                    ret !== null ? (
                                      <span
                                        className={ret >= 0 ? 'profit' : 'loss'}
                                      >
                                        {ret > 0
                                          ? '+' + Number(ret).toFixed(2)
                                          : Number(ret).toFixed(2)}
                                      </span>
                                    ) : null
                                  )}
                                </div>
                                <div>
                                  {getTotalPL(runner).map((ret) =>
                                    ret !== null ? (
                                      <span
                                        className={ret >= 0 ? 'profit' : 'loss'}
                                      >
                                        {ret > 0
                                          ? '+' + Number(ret).toFixed(2)
                                          : Number(ret).toFixed(2)}
                                      </span>
                                    ) : null
                                  )}
                                </div>
                              </TableCell>
                              <TableCell className="odds-cell">
                                <div className="odds-block odds-web-view back-odds-block">
                                  {runner.backPrices.length > 0 ? (
                                    runner.backPrices.map((odds, idx) => (
                                      <ExchOddBtn
                                        disable={true}
                                        mainValue={odds.price}
                                        subValue={odds.size}
                                        showSubValueinKformat={true}
                                        oddType="back-odd"
                                        valueType="matchOdds"
                                        oddsSet={[
                                          runner.backPrices[0]
                                            ? runner.backPrices[0].price
                                            : 0,
                                          runner.backPrices[1]
                                            ? runner.backPrices[1].price
                                            : 0,
                                          runner.backPrices[2]
                                            ? runner.backPrices[2].price
                                            : 0,
                                        ]}
                                        key={idx}
                                        // onClick={() => {
                                        //   addExchangeBet({
                                        //     minStake: minStake,
                                        //     maxStake: maxStake,
                                        //     eventId:
                                        //       outrightEventData.eventId.toString(),
                                        //     eventName: 'WORLD_CUP',
                                        //     marketId:
                                        //       outrightEventData.markets[0]
                                        //         .marketId,
                                        //     marketName:
                                        //       outrightEventData?.markets[0]
                                        //         .marketName,
                                        //     oddsPrice: odds.price,
                                        //     oddsSize: odds.size,
                                        //     type: 'BACK',
                                        //     stake: 0,
                                        //     betType: 'OT',
                                        //     outcomeId: runner.selectionId,
                                        //     outcomeName: runner.runnerName,
                                        //     competitionId:
                                        //       outrightEventData.competitionId,
                                        //     eventTypeId:
                                        //       outrightEventData.sportId,
                                        //   });
                                        // }}
                                      />
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <div className="odds-block odds-mob-view">
                                  <ExchOddBtn
                                    disable={true}
                                    mainValue={runner.backPrices[0].price}
                                    subValue={runner.backPrices[0].size}
                                    showSubValueinKformat={true}
                                    oddType="back-odd"
                                    valueType="matchOdds"
                                    // onClick={() => {
                                    //   addExchangeBet({
                                    //     minStake: minStake,
                                    //     maxStake: maxStake,
                                    //     eventId:
                                    //       outrightEventData.eventId.toString(),
                                    //     eventName: 'WORLD_CUP',
                                    //     marketId:
                                    //       outrightEventData.markets[0].marketId,
                                    //     marketName:
                                    //       outrightEventData?.markets[0]
                                    //         .marketName,
                                    //     oddsPrice: runner.backPrices[0].price,
                                    //     oddsSize: runner.backPrices[0].size,
                                    //     type: 'BACK',
                                    //     stake: 0,
                                    //     betType: 'OT',
                                    //     outcomeId: runner.selectionId,
                                    //     outcomeName: runner.runnerName,
                                    //     competitionId:
                                    //       outrightEventData.competitionId,
                                    //     eventTypeId: outrightEventData.sportId,
                                    //   });
                                    // }}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="odds-cell">
                                <div className="odds-block odds-web-view">
                                  {runner.layPrices.length > 0 ? (
                                    runner.layPrices.map((odds, idx) => (
                                      <ExchOddBtn
                                        mainValue={odds.price}
                                        subValue={odds.size}
                                        showSubValueinKformat={true}
                                        oddType="lay-odd"
                                        valueType="matchOdds"
                                        disable={true}
                                        oddsSet={[
                                          runner.layPrices[0]
                                            ? runner.layPrices[0].price
                                            : 0,
                                          runner.layPrices[1]
                                            ? runner.layPrices[1].price
                                            : 0,
                                          runner.layPrices[2]
                                            ? runner.layPrices[2].price
                                            : 0,
                                        ]}
                                        key={idx}
                                        // onClick={() => {
                                        //   addExchangeBet({
                                        //     minStake: minStake,
                                        //     maxStake: maxStake,
                                        //     eventId:
                                        //       outrightEventData.eventId.toString(),
                                        //     eventName: 'WORLD_CUP',
                                        //     marketId:
                                        //       outrightEventData.markets[0]
                                        //         .marketId,
                                        //     marketName:
                                        //       outrightEventData?.markets[0]
                                        //         .marketName,
                                        //     oddsPrice: odds.price,
                                        //     oddsSize: odds.size,
                                        //     type: 'LAY',
                                        //     stake: 0,
                                        //     betType: 'OT',
                                        //     outcomeId: runner.selectionId,
                                        //     outcomeName: runner.runnerName,
                                        //     competitionId:
                                        //       outrightEventData.competitionId,
                                        //     eventTypeId:
                                        //       outrightEventData.sportId,
                                        //   });
                                        // }}
                                      />
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <div className="odds-block mob-view">
                                  <ExchOddBtn
                                    disable={true}
                                    mainValue={runner.layPrices[0].price}
                                    subValue={runner.layPrices[0].size}
                                    showSubValueinKformat={true}
                                    oddType="lay-odd"
                                    valueType="matchOdds"
                                    // onClick={() => {
                                    //   addExchangeBet({
                                    //     minStake: minStake,
                                    //     maxStake: maxStake,
                                    //     eventId:
                                    //       outrightEventData.eventId.toString(),
                                    //     eventName: 'WORLD_CUP',
                                    //     marketId:
                                    //       outrightEventData.markets[0].marketId,
                                    //     marketName:
                                    //       outrightEventData?.markets[0]
                                    //         .marketName,
                                    //     oddsPrice: runner.layPrices[0].price,
                                    //     oddsSize: runner.layPrices[0].size,
                                    //     type: 'LAY',
                                    //     stake: 0,
                                    //     betType: 'OT',
                                    //     outcomeId: runner.selectionId,
                                    //     outcomeName: runner.runnerName,
                                    //     competitionId:
                                    //       outrightEventData.competitionId,
                                    //     eventTypeId: outrightEventData.sportId,
                                    //   });
                                    // }}
                                  />
                                </div>
                              </TableCell>
                            </TableRow>
                          </>
                        )
                    )}
                  </>
                ) : (
                  <>
                    {/* // <TableRow>
                  //   <TableCell colSpan={3}>
                  //     <div className="be-table-msg-text">
                  //       No outright markets at this moment
                  //     </div>
                  //   </TableCell>
                  // </TableRow> */}

                    {loading ? (
                      <div className="odds-mob-view">
                        <Spinner />
                      </div>
                    ) : null}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Modal
            open={infoDilalog.launch}
            closeHandler={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: '4',
              })
            }
            customClass="light-bg-title"
            title="Rules"
            size="md"
          >
            <MarketTermsCondi eventTypeID={infoDilalog.eventTypeID} />
          </Modal>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
  };
};
const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExchOutrightsEventTable);
